import styled from "styled-components";
import { Link } from "react-router-dom";
import globalStyles from "../../constants/globalStyles/theme.json";

const { colors } = globalStyles;

export const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70vh;
  text-align: center;
`;

export const StyledHeader = styled.h1`
  font-size: 5rem;
  color: ${colors.primary.green};
  margin-bottom: 1rem;
`;

export const StyledText = styled.p`
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

export const StyledLink = styled(Link)`
  font-size: 1.2rem;
  color: ${colors.primary.green};
  text-decoration: none;
  border: 1px solid ${colors.primary.green};
  padding: 0.5rem 1rem;
  border-radius: 5px;
  transition: 0.3s;

  &:hover {
    background: ${colors.primary.brown};
    border: 1px solid ${colors.primary.brown};
    color: white;
  }
`;
